<template>
	<div class="pages">
		<navTitle><div class="pageTitle">我的活动</div></navTitle>
		<div class="navTitle flex flex-align-center">
			<div @click="changeType(1)" class="navTitle-item" :class="{'navTitle-itemActive': type == 1}">进行中</div>
			<div @click="changeType(2)" class="navTitle-item" :class="{'navTitle-itemActive': type == 2}">已结束</div>
		</div>
		
		<template v-if="dataList.length > 0">
			<van-list
				v-model="loading"	
				:finished="finished"
				:immediate-check="false"
				finished-text="没有更多了"
				@load="onLoad"
				:offset="10"
			>
				<div class="activityList">
					<div class="activityList-item flex" v-for="item in dataList" :key="item.id"  @click="$router.push({ name: 'activityList_details', query: {id: item.id} })">
						<div class="item-img"><img :src="item.pic" alt="" /></div>

						<div class="item-info flex-1 flex flex-column">
							<div class="info-title">{{item.title}}</div>
							<div class="info-time flex flex-align-center">
								<img src="@/static/images/my/time.png" alt="" />
								<div>{{item.startTime}}开始</div>
							</div>
							<div class="info-location flex flex-align-center">
								<img src="@/static/images/my/location.png" alt="" />
								<div>{{item.address}}</div>
							</div>
							<div v-if="item.price*1 == 0" class="info-money">免费</div>
							<div v-else class="info-money">
								<span class="fonS-18">￥{{item.vip_apply_price}}</span>
								<span class="fonS-12 color-00">/起</span>
							</div>
						</div>
						<div v-if="item.quota != -1 && item.join_count>= item.quota" class="item-status item-statusAll">名额已满</div>
						<div v-else class="item-status item-statusAlready">{{item.join_count}}人已报名</div>
						<div v-if="item.end_time*1000 < new Date().getTime()" class="item-status item-statusEnd"></div>
					</div>
				</div>
			</van-list>
		</template>
		<div class="empty" v-if="dataList.length == 0">
			<div class="empty-img">
				<img src="@/static/images/index/emptySearch.png" alt="">
			</div>
			<div class="empty-text">暂无搜索到任何信息</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	watch: {},
	data() {
		return {
			type: 1,
			pageSize: 10,
			page: 1,
			dataList: [],
			loading: false,
      finished: false
		};
	},
	created() {
		this.getList()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '我的活动',
        desc: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		changeType(type) {
			this.type = type
			this.page = 1
			this.dataList = []
			this.getList()
		},
		onLoad() {
			this.page++;
      if (this.page > 1) {
        this.getList();
      }
		},
		getList() {
			this.$get('api/user/getMyActivity', {
				type: this.type,
				pageSize: this.pageSize,
				page: this.page
			}).then(res => {
				this.loading = false;
        let rows = res.data;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
        this.dataList = this.dataList.concat(rows);

			})
		}
	}
};
</script>

<style scoped lang="stylus">
.pages
	background #F6F6F6
	min-height 100vh
.navTitle
	padding 0 32px
	width 100%
	border-bottom 2px solid #E2E2E2
	height 94px
	position relative
	z-index 101
	// overflow hidden
	.navTitle-item
		font-size 28px
		color #000000
		margin-right 80px
	.navTitle-itemActive
		font-size 36px
		font-weight 800
		color #DE113C
		position relative
		&::after
			content ' '
			position absolute
			left 0
			bottom -24px
			width 100%
			height 6px
			background #DE113C
.activityStatus
	padding 24px 160px
	.status
		width 164px
		height 52px
		line-height 54px
		text-align center
		background #E2E2E2
		border-radius 26px
		font-size 28px
		color #000000
	.statusActive
		background #DE113C
		font-size 28px
		color #FFFFFF
.activityList
	padding 30px
	.activityList-item
		background-color #FFFFFF
		border-radius 20px
		margin-bottom 28px
		padding 20px 24px 32px 24px
		position relative
		.item-img
			width 188px
			height 188px
			margin-right 24px
			border-radius 20px
			img
				border-radius 20px
		.item-info
			.info-title
				font-size 30px
				color #000000
			.info-time
				font-size 24px
				color #B1B1B1
				margin-top 18px
				margin-bottom 18px
				img
					width 26px
					height 26px
					margin-right 12px
			.info-location
				font-size 24px
				color #B1B1B1
				margin-bottom 20px
				img
					width 21px
					height 26px
					margin-right 18px
			.info-money
				font-size 30px
				color #DE113C
		.item-status
			position absolute
			bottom 32px
			right 24px
		.item-statusAll
			font-size 24px
			color #9E9E9E
		.item-statusAlready
			font-size 24px
			color #DE113C
		.item-statusEnd
			z-index 10
			width 155px
			height 136px
			background-image url('~@/static/images/index/activityEnd.png')
			background-size 100% 100%
			background-position center
.empty
	background-color inherit
	.empty-img
		margin 280px auto 0 auto
		width 373px
		height 320px
		img
			width 100%
			height 100%
	.empty-text
		width 100%
		text-align center
		margin-top 22px
		font-size: 26px;
		color: #111111;
</style>
